import { List } from "@corpuscomplete/core/common/list";
import {
  type CircularProgressProps,
  CircularProgress,
} from "@corpuscomplete/web-ui/components/circular-progress";

export function ListProgress({
  list,
  size,
}: {
  list: List.Info | List.Preview;
  size?: CircularProgressProps["size"];
}) {
  const counts = List.itemStatusCounts(list);
  const donePercentage = List.itemDonePercentage(counts);

  return <CircularProgress value={donePercentage} size={size} />;
}
